// Auto-generated by set-version.js
export const buildInfo = {
  version: '1.0.0',
  hash: 'TEMP-DU9F7E',
  builtAt: '2026-11-04T12:14:01.369Z'
};
